import React from "react";
import "../styles/PrivacyPolicy.css";

const PrivacyPolicy = () => {
  const today = new Date().toISOString().split("T")[0];

  return (
    <div className="privacy-policy-container">
      <h1>📜 Privacy Policy</h1>
      <p><strong>Last Updated:</strong> {today}</p>

      <section>
        <h2>🔒 Our Commitment to Privacy</h2>
        <p>
          Welcome to RixxyMC! We prioritize user privacy and security. This policy explains how we manage 
          and protect your information while using our platform.
        </p>
      </section>

      <section>
        <h2>📊 Data Collection</h2>
        <p>
          RixxyMC <strong>does not collect or store personal information</strong>. However, we may gather 
          non-personal data, such as game performance analytics, to enhance user experience.
        </p>
      </section>

      <section>
        <h2>💰 Purchases & Transactions</h2>
        <p>
          RixxyMC provides in-game purchases, including ranks and virtual currency. Please note:
        </p>
        <ul>
          <li>⚠️ All transactions are <strong>final and non-refundable</strong>.</li>
          <li>🛒 Purchases are <strong>only processed through official and authorized channels</strong>.</li>
          <li>🚫 Avoid unauthorized sellers to <strong>prevent scams</strong>.</li>
        </ul>
      </section>

      <section>
        <h2>🛡️ Security & Fair Play</h2>
        <p>
          We enforce strict security measures to ensure a safe gaming environment. Users should 
          maintain strong passwords and never share account details.
        </p>
      </section>

      <section>
        <h2>📢 Policy Updates</h2>
        <p>
          RixxyMC reserves the right to update this policy when necessary. Any changes will be 
          announced through our official communication channels.
        </p>
      </section>

      <section>
        <h2>📩 Contact Us</h2>
        <p>
          If you have any questions or concerns, feel free to join our official Discord community:
        </p>
        <p>
          <a href="https://discord.rixxymc.fun/" target="_blank" rel="noopener noreferrer">
            👉 Join RixxyMC Discord
          </a>
        </p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
